import { ALLOWED_UI_THEMES, type UiThemeId } from './themeConstants';

export interface BuiThemeOption {
  id: UiThemeId;
  label: string;
  /** False when tokens are exported from Figma; true for interim palettes. */
  isPlaceholder: boolean;
}

/** UI switcher + persisted theme ids (single source of truth for labels). */
export const BUI_THEME_OPTIONS: readonly BuiThemeOption[] = [
  { id: 'pink-raspberry-grape', label: 'Pink Raspberry Grape', isPlaceholder: false },
  { id: 'lavender-lime-fruit-punch', label: 'Lavender Lime Fruit Punch', isPlaceholder: true },
  { id: 'blueberries-and-cream', label: 'Blueberries and Cream', isPlaceholder: true },
  { id: 'light', label: 'Light', isPlaceholder: true },
  { id: 'dark', label: 'Dark', isPlaceholder: true },
] as const;

export const BUI_THEME_IDS = ALLOWED_UI_THEMES;

export function getBuiThemeOption(id: UiThemeId): BuiThemeOption | undefined {
  return BUI_THEME_OPTIONS.find((t) => t.id === id);
}
